import { TextField } from '@mui/material';
import { FocusEvent, useContext } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';
import { EventProps } from '@/models/Event';
import { QuestionProps } from '@/models/Question';
import { stringHasValue } from '@/utils/stringUtil';
import { CurrentApplicationContext } from '@/Contexts/CurrentApplicationContext';

type NumParticipantsProps = {
  question: QuestionProps;
  eventInfo: EventProps;
  onEventChange: (updatedEvent: EventProps) => void;
  selectOnFocus: (e: FocusEvent<HTMLInputElement>) => void;
  onlyAllowNumbers: (value: string) => number | null;
};

export default function NumParticipants({
  question,
  eventInfo,
  onEventChange,
  selectOnFocus,
  onlyAllowNumbers,
}: NumParticipantsProps) {
  const { localeLanguageCode } = useContext(LocaleContext);
  const { canEdit } = useContext(CurrentApplicationContext);

  const inputChanged = (value: number | null) => {
    onEventChange({
      ...eventInfo,
      numParticipants: value,
    });
  };

  if (!stringHasValue(localeLanguageCode)) return <></>;

  const languageCode = localeLanguageCode;
  const label =
    question?.eventType?.participantTextTranslations != null &&
    languageCode != null &&
    languageCode !== ''
      ? (question.eventType.participantTextTranslations[languageCode] ?? '')
      : '';

  return (
    <TextField
      key='dosis'
      label={label}
      required={question?.questionNeeded}
      value={eventInfo?.numParticipants?.toLocaleString()}
      onChange={(e) => {
        const v = onlyAllowNumbers(e.target.value);
        inputChanged(v);
      }}
      onFocus={selectOnFocus}
      disabled={!canEdit}
      variant='outlined'
      error={eventInfo?.numParticipants == null}
    />
  );
}
